import * as yup from 'yup';
const validCharacters = /^[a-zA-Z\-' ]*$/;
const validCharactersErrorMessage = "Only letters, spaces, hyphens and apostrophes are allowed.";
const validSpecialCharacter = /^(?=.*[(!@#$%^&*)])/;
const validPasswordErrorMessage = `Invalid password`;

const Schema = yup.object({
	firstName: yup.string()
		.required("First name required")
		.max(24, "Maximum 24 letters")
		.matches(validCharacters, validCharactersErrorMessage),

	lastName: yup.string()
		.required("Last name required")
		.max(24, "Maximum 24 letters")
		.matches(validCharacters, validCharactersErrorMessage),

	password1: yup.string()
		.required("Password required")
		.min(10, "Minimum 10 characters")
		.test("isValidPassword", validPasswordErrorMessage, (value, context) => {
			const hasUpperCase = /[A-Z]/.test(value);
			const hasLowerCase = /[a-z]/.test(value);
			const hasNumber = /[0-9]/.test(value);
			const hasSpecialCharacter = validSpecialCharacter.test(value);
			const consecutiveLimit = /(.)\1{2,}/.test(value);
			let validConditions = 0;
			const numberOfMustBeValidConditions = 3;
			const conditions = [hasLowerCase, hasUpperCase, hasNumber, hasSpecialCharacter];
			conditions.forEach((condition) =>
				condition ? validConditions++ : null
			);
			return (validConditions >= numberOfMustBeValidConditions && !consecutiveLimit);
		}),

	password2: yup.string()
		.required("Passwords do not match")
		.oneOf([yup.ref("password1"), null])
});

export default Schema;
